import { CHART_FONT_FAMILY } from "@/pages/dashboard/components/Chart/_config/constant";

export const  COMMON_VERTICAL_LINE_GRID = {
  left: '16%',
  right: '16%',
  bottom: '6%',
  top: '10%',
  containLabel: true,
};

// 公共字体配置
export const COMMON_TEXT_STYLE =  {
  fontFamily: CHART_FONT_FAMILY
};

export const COMMON_TOOLTIP = {
  show: true,
  trigger: 'axis',
  backgroundColor: 'rgba(255, 255, 255, 0.75)',
  borderWidth: 0,
  borderRadius: 6,
  textStyle: {
    color: '#FFFFFF',
    fontSize: 12,
  },
  confine: true,
  position: 'center',
  // hideDelay: 0,
  triggerOn: 'mousemove',
  padding: 0,
};

// 最大值配置
export const SCALE_MAX_NUMBER = 100;
export const SCALE_MIM_NUMBER = 0;
// 中心点基准设置
export const SCALE_BAISIC_NUMER = 50;

export const COMMON_VERTICAL_XAXIS_CONFIG = {
  // gridIndex: 0,
  type: 'value',
  show: false,
  min: SCALE_MIM_NUMBER,
  max: SCALE_MAX_NUMBER,
};

export const COMMON_VERTICAL_YAXIS_CONFIG = {
  type: 'category',
  boundaryGap: false,
  show: true,
  axisLine: {
    show: false
  },
  axisTick: {
    show: false
  },
  axisLabel: {
    show: false
  },
  // 翻转 y 轴,使数据看起来是从上到下渲染，而不是从下到上，导致和表格的数据渲染方向相反
  inverse: true,
  splitLine: {
    show: true,
    lineStyle: {
      color: 'rgba(0,0,0,0.1)',
      type: 'solid', // 也可以是 'solid', 'dotted' 等
      width: 1
    }
  }
};

// 颜色配置
export const COMMON_VERTICAL_COLOR = [ '#5086F3','#F19E55'];
